import { extendTailwindMerge } from 'tailwind-merge';

// Register the custom @theme scales (parsed from index.css into __TW_SCALES__),
// else twMerge mistakes custom typography utilities for text colors and drops
// them, and cannot dedupe the numeric radius scale.
const { text, radius, shadow } = __TW_SCALES__;

export const twMerge = extendTailwindMerge({
  extend: {
    theme: { text, radius, shadow },
  },
});
